import React, { CSSProperties } from "react";

interface IProps {
  color: string;
  size: number;
  style?: CSSProperties;
}

export const CheckIcon = (props: IProps) => (
  <svg
    style={props.style}
    width={`${props.size}px`}
    height={`${Math.round((props.size * 3) / 4)}px`}
    viewBox="0 0 20 15"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Step2" transform="translate(-294.000000, -453.000000)">
        <g id="Group-12" transform="translate(293.000000, 376.000000)">
          <g id="baseline-assistant-24px" transform="translate(1.000000, 77.000000)">
            <g id="tick">
              <path
                d="M16.9194922,0.00428571429 L7.86304688,9.20448413 C7.61894531,9.45246032 7.22316406,9.45246032 6.9790625,9.20448413 L3.08050781,5.24404762 L0,8.37345238 L5.88074219,14.347619 C6.28925781,14.762619 6.84332031,14.995754 7.42101563,14.995754 C7.99867188,14.995754 8.55277344,14.7625794 8.96125,14.347619 L20,3.13365079 L16.9194922,0.00428571429 Z"
                id="Path"
                fill={props.color}
              ></path>
              <g id="Group" opacity="0.1" transform="translate(6.132812, 2.063492)" fill="#000000">
                <path
                  d="M12.8484766,0.0352380952 L1.19492188,11.8738095 C0.8725,12.2013095 0.467070312,12.4246825 0.0290234375,12.524246 C0.394765625,12.7875397 0.834023437,12.9321825 1.28820313,12.9321825 C1.86585938,12.9321825 2.41996094,12.6990079 2.8284375,12.2840476 L13.8671875,1.07007937 L12.8484766,0.0352380952 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
